import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaParecerGestorRecursoConcedidoInicio: [],
    buscaParecerGestorRecursoConcedidoSucesso: ['parecerGestorRecursoConcedido'],
    buscaParecerGestorRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaParecerGestorRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaParecerGestorRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarParecerGestor(filtro)
            .then(response => dispatch(Creators.buscaParecerGestorRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaParecerGestorRecursoConcedidoErro(error)))
    }
}

const buscaParecerGestorRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaParecerGestorRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaParecerGestorRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.parecerGestorRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PARECER_GESTOR_RECURSO_CONCEDIDO_INICIO]: buscaParecerGestorRecursoConcedidoInicio,
    [Types.BUSCA_PARECER_GESTOR_RECURSO_CONCEDIDO_ERRO]: buscaParecerGestorRecursoConcedidoErro,
    [Types.BUSCA_PARECER_GESTOR_RECURSO_CONCEDIDO_SUCESSO]: buscaParecerGestorRecursoConcedidoSucesso,
})
